/**
 * Owner: Masa Bayu
 * File: page.tsx
 * Date:Time: 2026-10-05 16:40
 * Description: Fasa 33-B live · QxWriterEditor shell · StructuredPage mock.
 *
 * Note: mounted by RoutePanel at /p19-writer.
 */

import type { ReactElement } from 'react';
import {
  QxWriterEditor,
  type StructuredPage,
} from '@qx/qx-universal-engine';
import '../p02/p02-live.css';

const mockPage: StructuredPage = {
  visualLayer: [],
  headerLayer: [
    {
      id: 'h1',
      type: 'text',
      bbox: { x: 0, y: 0, width: 100, height: 24 },
      textContent: 'BAB TIGA',
      font: {
        family: 'CinzelDecorative',
        weight: 900,
        size: 24,
        style: 'normal',
      },
      color: '#8B7355',
    },
  ],
  bodyLayer: [
    {
      id: 'b1',
      type: 'text',
      bbox: { x: 0, y: 0, width: 420, height: 14 },
      textContent:
        'Teks badan. Hijrah adalah perpindahan yang membawa makna dan jatidiri.',
      font: {
        family: 'Calibri',
        weight: 400,
        size: 11,
        style: 'normal',
      },
      color: '#000000',
    },
  ],
  footerLayer: [],
  tableLayer: [],
  listLayer: [],
};

export default function P19WriterLivePage(): ReactElement {
  return (
    <div className="p02-live" data-p19-writer="" data-fasa33b-writer="">
      <header className="p02-live-header">
        <p className="p02-live-kicker">p19-writer · Fasa 33-B</p>
        <h1>QXWriterEditor · Lexical Shell</h1>
        <p className="p02-live-meta">
          StructuredPage → UniversalTextNode · justify body · HistoryPlugin
        </p>
      </header>
      <section className="p02-live-pane" aria-label="QXWriter Lexical editor">
        <h2>Live Editor</h2>
        <div className="p02-live-frame">
          <QxWriterEditor page={mockPage} />
        </div>
      </section>
    </div>
  );
}
